import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import Auth from '../helpers/Auth'

class Login extends Component {
  constructor(props) {
    super(props);

    this.login = this.login.bind(this);
  }

  login() {
    Auth.authenticate().then(() => {

    }).catch((err) => {
      console.log("Authenticated error", err);
    })
  }

  render() {
    if (this.props.user) {
      return (
        <Redirect to='/dashboard'/>
      )
    }

    return (
      <div>
        <Button onClick={this.login}>Login with Google</Button>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { user } = state.auth;
  return { user };
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js